import React from 'react';
import {
  Modal,
  ModalDialog,
  ModalClose,
  Typography,
  Button,
  Stack,
  Divider,
} from '@mui/joy';

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        variant="outlined"
        role="alertdialog"
        sx={{
          maxWidth: 500,
          borderRadius: 'md',
          p: 3,
          boxShadow: 'lg',
        }}
      >
        <ModalClose onClick={onClose} />
        <Typography
          component="h2"
          id="confirm-dialog-title"
          level="h4"
          textColor="inherit"
          fontWeight="lg"
          mb={1}
        >
          {title}
        </Typography>
        <Divider sx={{ my: 1 }} />
        <Typography id="confirm-dialog-description" textColor="text.tertiary" mb={3}>
          {message}
        </Typography>
        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <Button variant="plain" color="neutral" onClick={onClose}>
            {cancelText}
          </Button>
          <Button variant="solid" color="danger" onClick={onConfirm}>
            {confirmText}
          </Button>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};

export default ConfirmDialog; 